import { Controller } from '@hotwired/stimulus'
import { DirectUploader } from '~/plugins/direct_uploader.js'

export default class extends Controller {
  static targets = ['fileTemplateDiv', 'turboFrame', 'form', 'emptyStateDiv']

  handleClick() {
    this.formTarget.querySelector('input[type="file"]').click()
  }

  submitFiles() {
    const form = this.formTarget
    const formData = new FormData(form)
    form.requestSubmit()

    this.hideEmptyStateDiv()

    const files = formData.getAll('data_request[document][]').filter(file => file != '')

    files.forEach(file => {
      this.uploadFile(event.currentTarget, file)
      const newFileDiv = this.fileTemplateDivTarget.cloneNode(true)
      this.displayNewFileProgress(file.name, newFileDiv)
      this.removeNewFileProgress(file.name, newFileDiv)
    })

    this.hideNewFilesDivs()
  }

  // private

  uploadFile(input, file) {
    const url = input.dataset.directUploadUrl
    const direct_uploader = new DirectUploader(file, url)
    direct_uploader.start(input)
  }

  displayNewFileProgress(filename, newFileDiv) {
    this.fileTemplateDivTarget.after(newFileDiv)
    newFileDiv.classList.remove('hidden')
    newFileDiv.querySelector('[data-target="filenameDiv"]').innerHTML = filename
  }

  removeNewFileProgress(filename, newFileDiv) {
    const hiddenField = document.querySelector(`input[filename="${filename}"]`)
    const callback = (mutationList, observer) => {
      const uploadEnded = hiddenField.getAttribute('progress') == '100.0'
      if (uploadEnded) {
        this.markAsUploaded(newFileDiv)
        observer.disconnect()
      }
    }
    const observer = new MutationObserver(callback)
    const config = { attributes: true, childList: false }
    observer.observe(hiddenField, config)
  }

  hideEmptyStateDiv() {
    if (this.hasEmptyStateDivTarget) {
      this.emptyStateDivTarget.classList.add('hidden')
    }
  }

  markAsUploaded(newFileDiv) {
    const progressIcon = newFileDiv.querySelector('[data-target="progressIcon"]')
    const uploadedFileIcon = newFileDiv.querySelector('[data-target="uploadedFileIcon"]')
    progressIcon.classList.add('hidden')
    uploadedFileIcon.classList.remove('hidden')
  }

  hideNewFilesDivs() {
    const callback = (mutationList, observer) => {
      mutationList.forEach(_mutation => {
        this.fileTemplateDivTargets.forEach(div => div.classList.add('hidden'))
        observer.disconnect()
      })
    }

    const observer = new MutationObserver(callback)
    const config = { attributes: false, childList: true }
    observer.observe(this.turboFrameTarget, config)
  }
}
